import React from "react";
import classNames from "classnames";

import { Fader } from "@formant/ui/component/common/Fader";

import { ToggleSwitch } from "../common/ToggleSwitch";
import * as styles from "./TeleopArmSwitch.scss";

interface ITeleopArmSwitchProps {
    visible: boolean;
    enabled: boolean;
    highlight: boolean;
    onToggle: () => void;
}

export function TeleopArmSwitch(props: ITeleopArmSwitchProps) {
    const { visible, enabled, highlight, onToggle } = props;
    return (
        <Fader
            visible={visible}
            className={classNames(
                styles["teleop-arm-switch"],
                highlight && styles.highlight,
            )}
        >
            <ToggleSwitch
                showLabel={true}
                className={styles.switch}
                on={enabled}
                data-testid="teleop-unlock-switch"
                onClick={onToggle}
            >
                Unlock
            </ToggleSwitch>
        </Fader>
    );
}
